export default "__VITE_ASSET__B4i_QecH__"